module.exports = __webpack_public_path__ + "static/media/ot-courier-relay.6df9ce8c.svg";